<div class="filter-container">

    <app-search-inline [placeholderStr]="'Search Custom Metrics'" (keywordChange)="search($event)"
        data-cy="search-custom-metric-inline-wrapper"></app-search-inline>
        <button mat-raised-button class="rubii-btn add-btn" color="primary" data-cy="report-button-dashboard-create"
        (click)="create()"><mat-icon [inline]="true">add</mat-icon> Create</button>
</div>


<div class="rubii-table">

    <table style="max-width: 100%">
        <thead>
            <tr>
                <th class="report-name-th">Name</th>
                <th class="date-range-th">Date Created</th>
                <th class="last-modified-th">Last Modified</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let customMetric of customMetrics">
                <td class="report-name-td" [ngClass]="customMetric.status === CustomMetricStatus.Archived ? 'archived' : undefined">
                    <div>
                        <div class="report-name">
                            {{customMetric.name}}
                        </div>
                        <div class="icons">
                            <div class="rb rb-icon-edit img" [matTooltip]="'Edit'" *ngIf="customMetric.status === CustomMetricStatus.Active" data-cy="button-custom-metric-edit" (click)="edit(customMetric)"></div>
                            <div class="rb rb-icon-copy img" [matTooltip]="'Clone'" *ngIf="customMetric.status === CustomMetricStatus.Active" data-cy="button-custom-metric-clone" (click)="clone(customMetric)"></div>
                            <div class="rb rb-icon-archive img" [matTooltip]="'Archive'" *ngIf="customMetric.status === CustomMetricStatus.Active" data-cy="button-custom-metric-archive" (click)="archive(customMetric)"></div>
                            <div class="rb rb-icon-unarchive img" [matTooltip]="'Enable'" *ngIf="customMetric.status === CustomMetricStatus.Archived" data-cy="button-custom-metric-enable" (click)="enable(customMetric)"></div>
                        </div>
                    </div>
                </td>
                <td class="date-range-td" [ngClass]="customMetric.status === CustomMetricStatus.Archived ? 'archived' : undefined">{{customMetric.createtime | date:format:timezone}}</td>
                <td class="last-modified-td" [ngClass]="customMetric.status === CustomMetricStatus.Archived ? 'archived' : undefined">{{customMetric.lastModifiedTime| date:format:timezone}}</td>
            </tr>

            <tr>
                <td colspan="6">
                    <mat-paginator color="primary" (page)="pageChanged($event)" [length]="page.total"
                        [pageSize]="page.pageSize" showFirstLastButtons="true" [pageIndex]="page.pageId - 1"
                        [pageSizeOptions]="[5, 10, 25, 100]">
                    </mat-paginator>
                </td>
            </tr>
        </tbody>
    </table>
</div>